import type { CarouselA11yText } from '../types/brand-pillars'

/**
 * Default accessibility text for the brand pillars carousel.
 * Brand pillars are currently en-only (MCS only has en content for National Pen's initial launch).
 * TODO: source these from the i18n translation catalog once multi-locale support is added.
 */
export const DEFAULT_CAROUSEL_A11Y: CarouselA11yText = {
  label: 'Brand pillars',
  role: 'carousel',
  slideRole: 'slide',
  visibleSlides: '1 of {total}',
  dotsTemplate: 'Go to slide {slideNumber}',
}

/**
 * Minimal SWAN i18n translation keys required by AdaptiveCarousel for its accessibility labels.
 * These are hardcoded en strings because brand pillars ship en-only at launch (National Pen only).
 * Provided explicitly in the client-side hydration root because hydrateAndTrack creates a
 * standalone React root that does not inherit SwanProvider from the ubik framework.
 * TODO: replace with proper i18n catalog entries when brand pillars expands to non-English locales.
 */
export const SWAN_ADAPTIVE_CAROUSEL_TRANSLATIONS = {
  'adaptive-carousel-slide.aria-roledescription': 'slide',
  'adaptive-carousel-slide-picker-internal.accessible-text-for-button': 'Go to slide {{slideNumber}}',
  'adaptive-carousel-slide-picker-thumbnail.accessible-text-for-button': 'Go to slide {{slideNumber}}',
  'adaptive-carousel-slide-navigation-internal.accessible-text-for-next-button': 'Go to next slide',
  'adaptive-carousel-slide-navigation-internal.accessible-text-for-previous-button': 'Go to previous slide',
  'adaptive-carousel.accessible-text-for-slide': '{{current}} of {{totalSlides}}',
  'adaptive-carousel.accessible-text-for-visible-slides_one': 'Slide {{start}} of {{totalSlides}}',
  'adaptive-carousel.accessible-text-for-visible-slides_other': 'Slides {{start}} to {{end}} of {{totalSlides}}',
  'adaptive-carousel.aria-roledescription': 'carousel',
}
